<template>
  <div class="brandlogo">
    <img
      :src="imageSrc"
      :title="imageTitle"
      :class="getCurrentTheme.type"
    >
    <span
      v-if="getCurrentTheme.type === 'default'"
      class="logo-sub"
    >maps</span>
  </div>
</template>
<script>
import { image } from '@/helpers/assets'
import { mapGetters } from 'vuex'

export default {
  name: 'Logo',
  props: {
    organisation: {
      type: String,
      default: '',
    },
    image: {
      type: String,
      default: 'logo.png',
    },
  },
  computed: {
    ...mapGetters('config', ['getCurrentTheme']),
    imageSrc () {
      return image({ name: this.image })
    },
    imageTitle () {
      return this.organisation + ' logo'
    },
  },
}
</script>

<style scoped lang="scss">
$menu-height: 80px;

.brandlogo {
  position: relative;
  margin-top: calc(-0.2 * #{$menu-height});
  img {
    height: $menu-height;
    &.custom {
    max-height: 50px;
    margin-top: calc(0.2 * #{$menu-height});
  }
  }
  .logo-sub {
    font-size: calc(0.2 * #{$menu-height});
    color: #adb5bd;
    position: absolute;
    bottom: calc(0.02 * #{$menu-height});
    right: calc(0.25 * #{$menu-height});
  }
}
</style>
